<vc-dialog
    [(visible)]="visible"
    [title]="dialogTitle"
    [primaryLabel]="primaryLabel"
    [secondaryLabel]="'COMMON_UI.CANCEL' | transloco"
    [actionsOnLeft]="false"
    (primaryTrigger)="onDelete()">
    {{ dialogMessage }}
</vc-dialog>
